import { Grid, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import CustomButton from '../../../Components/CustomButton';
import Images from '../../../Utils/images';
import SearchInput from '../../../Components/SearchComponent';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../helpers/contants';
import { ViewBtns } from './ViewBtns';
import MyDocumentFilter from '../../MyDocument/component/MyDocumentFilter';
import React from 'react';
import ToolTipComponent from '../../../Components/ToolTipComponent';
import { ManageEntityRecordInfo } from '../../../types';

interface Props {
  title: any;
  isTabular?: boolean;
  setIsTabular?: any;
  onSearch?: any;
  isOrderSetting?: boolean;
  handleClearSearch?: any;
  isShowButton?: boolean;
  handleOpenDepartment?: any;
  setIsManage?: any;
  isManage?: boolean;
  isShowAddContactButton?: boolean;
  setContactOpen?: any;
  filter?: any;
  setFilter?: any;
  isShowBreadcrumb?: boolean;

  setData?: any;
  isShowViewBtn?: boolean;
  isShowAddEpisodeButton?: boolean;
  type?: string;
  searchKey?: string;
  productionName?: string;
  setSearchKey?: any;
  showBreadCrumb?: any;
  episodeId?: any;
  isContact?: any;
  searchPlaceholder?: string;
  productionId?: string;
  isDocumentFilter?: boolean;
  isSearch?: boolean;
  productionType?: string;
  className?: string;
  classNameSearch?: string;
  isAddProductionButton?: boolean;
  studioId?: string;
  studioName?: string;
  viewAllFilter?: React.ReactNode;
  isStudio?: boolean;
  btnText?: string;
  onClick?: any;
  isProduction?: boolean;
  onAddApproverLevel?: any;
  isAddProductionButtonDisabled?: boolean;
  isUploadDocumentDisabled?: boolean;
  isEditDisabled?: boolean;
  isShowEditButton?: boolean;
  isAddContactButtonDisabled?: boolean;
  isAddEpisodeSetDisabled?: boolean;
  onAddNewMemberFromOrderSettings?: () => void;
  isDisabled?: boolean;
  isDepartment?: boolean;
  isStudioDepartment?: boolean;
  titleRowActions?: React.ReactNode;
  filterConfig?: {
    disabled: string[];
    prefilled: string[];
  };
  entityScope?: { entityType?: string; entityId?: string };
  prefillEntityData?: { entityType: string; entity: any };
  manageEntityRecordInfo?: ManageEntityRecordInfo | null;
}

const HeadingRow: React.FC<Props> = props => {
  const {
    title,
    isTabular,
    setIsTabular,
    handleClearSearch,
    onSearch,
    isShowButton,
    handleOpenDepartment,
    isManage,
    setIsManage,
    productionName,
    isOrderSetting,
    isShowAddContactButton,
    setContactOpen,
    filter,
    setFilter,
    isShowBreadcrumb,
    setData,
    isShowViewBtn,
    isShowAddEpisodeButton,
    type,
    searchKey,
    setSearchKey,
    showBreadCrumb,
    episodeId,
    isContact,
    searchPlaceholder,
    productionId,
    isDocumentFilter,
    isSearch,
    productionType,
    className,
    classNameSearch,
    isAddProductionButton,
    studioId,
    studioName,
    viewAllFilter,
    isStudio,
    btnText,
    onClick,
    isProduction,
    onAddApproverLevel,
    isAddProductionButtonDisabled,
    isUploadDocumentDisabled,
    isEditDisabled,
    isShowEditButton = true,
    isAddContactButtonDisabled,
    isAddEpisodeSetDisabled,
    onAddNewMemberFromOrderSettings,
    isDisabled,
    isDepartment,
    isStudioDepartment,
    titleRowActions,
    filterConfig,
    entityScope,
    prefillEntityData,
    manageEntityRecordInfo,
  } = props;

  const navigate = useNavigate();

  return (
    <>
      <Grid
        container
        columnSpacing={titleRowActions ? 5 : undefined}
        spacing={titleRowActions ? undefined : 2}
        className={`mb-24 heading-row ${
          titleRowActions
            ? 'manage-entity-heading-row align-unset'
            : 'align-center'
        } ${className ? className : ''}`}
      >
        <Grid item md={titleRowActions ? 6 : 4} xs={12}>
          {titleRowActions ? (
            <div className="title-flex manage-entity-title-flex mb-10">
              <h1 className="MuiTypography-h3 fw600 mb-0">{title}</h1>
              {titleRowActions}
            </div>
          ) : (
            <h1 className="MuiTypography-h3 fw600 mb-10">{title}</h1>
          )}
          {isShowBreadcrumb ? showBreadCrumb() : null}
        </Grid>
        <Grid item md={titleRowActions ? 6 : 8} xs={12}>
          <div className="d-flex align-end flex-md-end flex-phn-wrap">
            {isShowEditButton && !isManage ? (
              <div className="pr-15">
                <IconButton
                  onClick={() => setIsManage(true)}
                  disabled={isEditDisabled}
                >
                  <i className="edit-grey-icon"></i>
                </IconButton>
              </div>
            ) : null}

            {isShowButton ? (
              <div className="pr-15">
                <CustomButton
                  size="medium"
                  variant="outlined"
                  text={'Upload Document'}
                  showIcon={true}
                  iconPosition="start"
                  iconType="image"
                  icon={Images.UploadIcon}
                  width="auto"
                  type="submit"
                  className="lg-height"
                  id={''}
                  onClick={handleOpenDepartment}
                  disabled={isUploadDocumentDisabled}
                />
              </div>
            ) : null}

            <div className="d-flex heading-buttons">
              {isOrderSetting ? (
                <div className="">
                  <CustomButton
                    size="medium"
                    variant="contained"
                    text={`Add New Member`}
                    showIcon={true}
                    iconPosition="start"
                    iconType="image"
                    icon={Images.Plus_White}
                    width="auto"
                    type="submit"
                    className="lg-height"
                    id={''}
                    onClick={onAddNewMemberFromOrderSettings}
                  />
                </div>
              ) : null}

              {isOrderSetting ? (
                <div className="">
                  <CustomButton
                    size="medium"
                    variant="outlined"
                    text={`Add Approval Level`}
                    showIcon={true}
                    iconPosition="start"
                    iconType="image"
                    icon={Images.Plus_Icon}
                    width="auto"
                    type="submit"
                    className="lg-height"
                    id={''}
                    onClick={onAddApproverLevel}
                    disabled={isDisabled}
                  />
                </div>
              ) : null}
            </div>

            {isDocumentFilter && (
              <div className="pr-15 heading-filter">
                <MyDocumentFilter
                  filter={filter}
                  setFilter={setFilter}
                  productionType={productionType}
                  filterConfig={filterConfig}
                  entityScope={entityScope}
                  prefillEntityData={prefillEntityData}
                />
              </div>
            )}

            {isShowAddContactButton ? (
              <div className="pr-15">
                <CustomButton
                  size="medium"
                  variant="outlined"
                  text={`Add ${
                    isContact
                      ? 'Contact'
                      : isStudio || isStudioDepartment
                      ? 'Studio Employee'
                      : 'Crew Member'
                  }`}
                  disabled={isAddContactButtonDisabled}
                  showIcon={true}
                  iconPosition="start"
                  iconType="image"
                  icon={Images.Plus_Icon}
                  width="auto"
                  type="submit"
                  className="lg-height"
                  id={''}
                  // onClick={() =>
                  //   navigate(ROUTES.ADD_CONTACT_PRODUCTS, {
                  //     state: { isOnlyCrew: true },
                  //   })
                  // }
                  onClick={() =>
                    isStudio || isProduction || isDepartment
                      ? onClick()
                      : setContactOpen(true)
                  }
                />
              </div>
            ) : null}
            {isShowAddEpisodeButton ? (
              <div className="pr-15">
                <CustomButton
                  size="large"
                  variant="outlined"
                  text={btnText}
                  showIcon={true}
                  disabled={isAddEpisodeSetDisabled}
                  iconPosition="start"
                  iconType="image"
                  icon={Images.Plus_Icon}
                  width="auto"
                  type="submit"
                  className=""
                  id={''}
                  onClick={() => {
                    if (type === 'episode') {
                      navigate(
                        `${ROUTES?.CREATE_EPISODE}?productionId=${productionId}&name=${productionName}`,
                      );
                    } else {
                      navigate(
                        `${ROUTES?.CREATE_SET}?productionId=${productionId}&name=${productionName}&episodeId=${episodeId}`,
                      );
                    }
                  }}
                />
              </div>
            ) : null}
            {isAddProductionButton ? (
              <div className="pr-15">
                <CustomButton
                  size="medium"
                  variant="outlined"
                  text={`Add Project/Live Event`}
                  showIcon={true}
                  iconPosition="start"
                  iconType="image"
                  icon={Images.Plus_Icon}
                  width="auto"
                  type="submit"
                  className="lg-height"
                  disabled={isAddProductionButtonDisabled}
                  id={''}
                  onClick={() => {
                    if (studioId && studioName) {
                      navigate(
                        `${ROUTES.CREATE_PRODUCTION}?studioId=${studioId}&studioName=${studioName}`,
                      );
                    } else {
                      navigate(ROUTES.CREATE_PRODUCTION);
                    }
                  }}
                />
              </div>
            ) : null}
            {viewAllFilter && (
              <div className="filter-wrapper">{viewAllFilter}</div>
            )}

            {(!isSearch || isOrderSetting) && (
              <div className={`heading-search pr-15 ${classNameSearch}`}>
                <SearchInput
                  {...(setData ? { setData } : {})}
                  placeholder={
                    searchPlaceholder ? searchPlaceholder : 'Search here...'
                  }
                  className="sm outlined"
                  setQuery={(value: any) => onSearch(value)}
                  searchkey={searchKey}
                  setSearchKey={setSearchKey}
                  handleClearSearch={() => {
                    if (setData) {
                      setData([]);
                    }
                    handleClearSearch();
                  }}
                />
              </div>
            )}

            {isShowViewBtn ? (
              <div className=" mt-6">
                <ViewBtns
                  isTabular={isTabular}
                  setIsTabular={() => {
                    setData([]);
                    setFilter();
                    setSearchKey('');
                    setIsTabular(!isTabular);
                  }}
                  setFilter={setFilter}
                  className="mr-0"
                />
              </div>
            ) : null}
            {manageEntityRecordInfo ? (
              <div className="manage-entity-record-info-trigger">
                <ToolTipComponent
                  theme="light"
                  arrow
                  position="bottom-end"
                  title={
                    <div className="manage-entity-record-info">
                      <p className="manage-entity-record-info-label">
                        Modified
                      </p>
                      <p className="manage-entity-record-info-value">
                        {manageEntityRecordInfo.modifiedDate} by{' '}
                        {manageEntityRecordInfo.modifiedBy}
                      </p>
                      <p className="manage-entity-record-info-label">Created</p>
                      <p className="manage-entity-record-info-value">
                        {manageEntityRecordInfo.createdDate} by{' '}
                        {manageEntityRecordInfo.createdBy}
                      </p>
                    </div>
                  }
                >
                  <IconButton
                    className="manage-entity-record-info-btn"
                    aria-label="Record info"
                  >
                    <InfoOutlinedIcon className="manage-entity-record-info-icon" />
                  </IconButton>
                </ToolTipComponent>
              </div>
            ) : null}
            {/* ) : null} */}
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default HeadingRow;
